<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :table-config-options="{ endpoint: `${MODULE_NAME}/checkMonitoringListInnovation`}"
    :filter-class="filterClass"
  >
    <template #before-search>
      <b-dropdown
        variant="success"
        toggle-class="text-decoration-none"
        no-caret
        class="mr-2"
      >
        <template #button-content>
          <b-icon icon="file-earmark-excel" /> Excel
        </template>
        <download-file dispatch-action="staticModule/checkMonitoringListQueue">
          {{ $t('Download') }}
        </download-file>
      </b-dropdown>
    </template>
    <template #cell(quarter)="{data}">
      {{ data.item.period + '/' + data.value }}
    </template>
    <template #cell(direction_name)="{data}">
      {{ $langName(data.value) }}
    </template>
    <template #cell(dc_type)="{data}">
      {{ $langName(data.value) }}
    </template>
    <template #cell(organization_name)="{data}">
      {{ $langName(data.value) }}
    </template>
    <template #cell(status)="{data}">
      <b-badge :variant="getStatus(data.value).color">
        {{ $langName(getStatus(data.value)) }}
      </b-badge>
    </template>
    <template #cell(reason_status)="{data}">
      <b-badge :variant="getReasonStatus(data.value).color">
        {{ $langName(getReasonStatus(data.value)) }}
      </b-badge>
    </template>
    <template #cell(monitoring_report.status)="{data}">
      <b-badge :variant="getReportStatusColor(data.value)">
        {{ $langName(getReportStatus(data.value).name) }}
      </b-badge>
    </template>
    <template #cell(files)="{data}">
      <b-link
        v-b-toggle.sidebar-monitoring-report-files
        @click="showFiles(data.item.monitoring_report)"
      >{{ $t('Files') }}</b-link>
    </template>
    <template #create-body>
      <monitoring-report-files />
    </template>
  </l-table>
</template>

<script>

import { onUnmounted } from '@vue/composition-api'
import {
  BBadge, VBToggle, BLink, BDropdown, BIcon,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LTable from '@/views/components/LTable.vue'
import store from '@/store'
import checkMonitoringModule from '@/store/check-monitoring'
import reportMonitoringModule from '@/store/monitoring-report'
import MonitoringInno from '@/views/components/filters/service/MonitoringInno'
import MonitoringReportFiles from '@/views/pages/monitoring-report/MonitoringReportFiles.vue'
import DownloadFile from '@/views/pages/apply-document/components/DownloadFile.vue'

export default {
  name: 'CheckMonitoringInno',
  components: {
    BIcon,
    DownloadFile,
    BDropdown,
    MonitoringReportFiles,
    BBadge,
    LTable,
    BLink,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  computed: {
    statuses() {
      return this.$store.state[this.MODULE_REPORT_NAME].statuses
    },
  },
  mounted() {
    this.$store.dispatch('staticModule/universityList')
    this.$store.dispatch('staticModule/regions')
    this.$store.dispatch('staticModule/periodList', { limit: 9999, ordering: '-admission_year' })
  },
  methods: {
    getStatus(statusCode) {
      return this.$store.getters['staticModule/getCheckMonitoringStatusCheckStatus'](statusCode)
    },
    getReasonStatus(statusReasonCode) {
      return this.$store.getters['staticModule/getCheckMonitoringReasonStatusCheckStatus'](statusReasonCode)
    },
    getReportStatusColor(status) {
      const select = this.statuses.find(item => item.id === Number(status))
      return select ? select.color : 'secondary'
    },
    getReportStatus(status) {
      return this.statuses.find(item => item.id === Number(status))
    },
    showFiles(reportMonitoring) {
      this.$store.commit(`${this.MODULE_REPORT_NAME}/GET`, reportMonitoring)
      this.$store.commit(`${this.MODULE_REPORT_NAME}/FILES`, [])
      this.$store.dispatch(`${this.MODULE_REPORT_NAME}/files`, reportMonitoring)
    },
  },
  setup() {
    const filterClass = new MonitoringInno()
    const MODULE_NAME = 'checkMonitoring'
    const MODULE_REPORT_NAME = 'monitoringReport'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, checkMonitoringModule)
    if (!store.hasModule(MODULE_REPORT_NAME)) store.registerModule(MODULE_REPORT_NAME, reportMonitoringModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME, checkMonitoringModule)
      if (store.hasModule(MODULE_REPORT_NAME)) store.unregisterModule(MODULE_REPORT_NAME, reportMonitoringModule)
    })
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'full_name', label: 'Full name', sortable: true },
      { key: 'monitoring_report.course', label: 'Course', sortable: true },
      { key: 'direction_name', label: 'Direction', sortable: true },
      { key: 'dc_type', label: 'Dc Type', sortable: true },
      { key: 'quarter', label: 'Admission period', sortable: true },
      { key: 'organization_name', label: 'Organization', sortable: true },
      { key: 'advisor_name', label: 'Advisor', sortable: true },
      { key: 'scientific_work_name', label: 'Scientific work name', sortable: true },
      { key: 'phone', label: 'Phone', sortable: true },
      { key: 'files', label: 'Files', sortable: true },
      { key: 'status', label: 'Monitoring report status', sortable: true },
      { key: 'monitoring_report.status', label: 'Advisor status', sortable: true },
      { key: 'reason_status', label: 'Reason', sortable: true },
    ]

    return {
      MODULE_REPORT_NAME,
      MODULE_NAME,
      tableColumns,
      filterClass,
    }
  },
}
</script>

<style scoped>

</style>
